import promisePolyfill from "promise-polyfill";

(function() {
  // When a browser does not support Promises, assign polyfill to window object.
  if (!window.Promise) {
    window.Promise = promisePolyfill;
  }

  const stateLists = document.querySelectorAll(".us-states-and-territories");

  stateLists.forEach(stateList => {
    stateList.addEventListener("submit", event => {
      event.preventDefault();
      const stateCodeDropdown = stateList.querySelector("select");
      const stateCode =
        stateCodeDropdown.options[stateCodeDropdown.selectedIndex].value;
      const stateName =
        stateCodeDropdown.options[stateCodeDropdown.selectedIndex].text;

      if (stateCode === "") {
        document.getElementById("eeo-complaints").innerHTML =
          "<p class='margin-top-1'>Please select a State or Territory</p>";
        return;
      }

      // Toggle visibility of loading message before state offices can be
      // rendered.
      document.getElementById("eeo-complaints").classList.add("jp-hidden");
      document
        .querySelector(".partner-resources__loading")
        .classList.remove("jp-hidden");
      document
        .querySelector(".partner-resources__loading")
        .setAttribute("aria-hidden", "false");

      const stateOfficePromise = fetch(
        `/api/partner-resources/offices?search=${stateCode}&regional=false`,
        {
          method: "GET"
        }
      ).then(response => response.json());

      const countPromises = Promise.all([stateOfficePromise]);

      countPromises.then(response => {
        let dataItems = response[0].value;
        console.log(dataItems);
        //
        // California has both a SAA and OA contact.  We only want OA.
        // Hopefully CA will be the only state with both since the data
        // doesn't provide a good way to differentiate the two.
        if (stateCode === "CA") {
          dataItems = dataItems.filter(item => item.source === "oa");
        }

        // After successful response, the loading message will be hidden and
        // replaced with each office's contact information.
        document
          .querySelector(".partner-resources__loading")
          .classList.add("jp-hidden");
        document
          .querySelector(".partner-resources__loading")
          .setAttribute("aria-hidden", "true");
        document.getElementById("eeo-complaints").classList.remove("jp-hidden");

        let offices = "";

        // Loop through each office returned by the Partner Resource API and then
        // render all HTML for the Partner Resource paragraph template.
        dataItems.forEach(data => {
          let officeHTML;

          window.history.replaceState(null, null, `?state=${stateCode}`);

          if (data.source === "oa") {
            officeHTML = `<p class="margin-top-2">You have selected <strong>${stateName}</strong>, which is administered by the federal
                  Office of Apprenticeship in the U.S. Department of Labor. Please follow the steps below to file your complaint.</p>`;

            if (window.drupalSettings.oa.eeo_complaints.instructions !== "") {
              officeHTML +=
                window.drupalSettings.oa.eeo_complaints.instructions;
            }
          }

          if (data.source === "saa") {
            let additionalProperties = JSON.parse(data.additionalProperties);
            officeHTML = `<p class="margin-top-2">You have selected <strong>${stateName}</strong>, which is recognized as a
                State Apprenticeship Agency by the U.S. Department of Labor.  Visit the website for that agency or
                connect with their point-of-contact using the information listed below:</p>`;
            officeHTML += `<address>`;
            officeHTML += `<p>Contact: ${additionalProperties.contactPerson}</p>`;

            // Not everyone wants a phone call.
            if (additionalProperties.phone) {
              officeHTML += `<p>Phone: ${additionalProperties.phone}</p>`;
            }

            if (additionalProperties.email) {
              officeHTML += `<p>Email: <a href="mailto:${additionalProperties.email}" aria-label="Email ${additionalProperties.email}">${additionalProperties.email}</a></p>`;
            }

            if (additionalProperties.orgUrl) {
              officeHTML += `<p>Website: <a href="${additionalProperties.url}">${additionalProperties.url}</a></p>`;
            }

            // Sometimes the Address line 2 is empty but why not be extra careful?
            const address1 = data.Address.line1 !== "" ? `${data.Address.line1 }` : "";
            const address2 = data.Address.line2 !== "" ? ` ${data.Address.line2}` : "";

            officeHTML += `<p>Address: ${address1}${address2}, ${data.Address.city}, ${data.Address.state} ${data.Address.zip}</p>`;

            officeHTML += `</address>`;
          }

          if (window.drupalSettings.oa.eeo_complaints.disclaimer !== "") {
            officeHTML += window.drupalSettings.oa.eeo_complaints.disclaimer;
          }

          // Concatenated HTML stored for rendering later.
          offices += officeHTML;
        });

        if (offices === "") {
          offices =
            "<p class='margin-top-1'>There are no offices at the" +
            " selected" +
            " location.</p>";
        }

        document.getElementById("eeo-complaints").innerHTML = offices;
      });
    });
  }, false);
})();
